$(document).on('turbolinks:load', function(){
  var autoSaveTimeoutId;
  var blogFormBody = $('form#new-user-blog-form #blog_body');
  var blogFormTitle = $('form#new-user-blog-form #blog_title');
  $('body').on('input propertychange change', 'form#new-user-blog-form textarea, form#new-user-blog-form input', function() {
    if ((blogFormBody != '') || (blogFormTitle != '')) {
      saveBlog();
    }
  });

  $("body").on('DOMSubtreeModified', "form#new-user-blog-form .fr-element.fr-view", function() {
    if (blogFormBody.val() != '') {
      saveBlog();
    }
  });

  function saveBlog() {
    clearTimeout(autoSaveTimeoutId);
    autoSaveTimeoutId = setTimeout(function() {
      var form = document.getElementById('new-user-blog-form');
      if (form) {
        var formData = new FormData(form);
        var url = $('#new-user-blog-form').data('draft-path');
        $.ajax({
          url: url,
          type: 'POST',
          data: formData,
          processData: false,
          contentType: false,
          beforeSend: function(){
            $('.saving-indicator').removeClass('d-none');
            $('.saving-indicator').html('Saving...');
          },
          error: function(){},
          success: function(){}
        });
      }
      
    }, 2000);
  }
});